<div class="flex flex-auto align-items-center justify-content-start w-full">
    <p-autoComplete #practiceSearchComponent appendTo="body" [(ngModel)]="facility" [suggestions]="groupedFacilitySuggestions" [group]="true"
                        (completeMethod)="facilitySearch($event)" [placeholder]="placeholder" optionLabel="facility.name"
                        class="m-2 flex w-full" styleClass="flex w-full" inputStyleClass="flex w-full" (onSelect)="selectFacility($event)">
        <ng-template let-group pTemplate="group">
            <div class="flex align-items-center">
                <span>{{ group.label }}</span>
            </div>
        </ng-template>
        <ng-template let-item pTemplate="item">
            <div class="flex align-items-center gap-2" >
                <div class="flex" > {{item.facility.npiName}} {{item.location.street1}} {{ item.location.city }}, {{ item.location.state}} {{item.location.zipCode}} </div>

            </div>
        </ng-template>
    </p-autoComplete>
</div>